import { create } from 'zustand';
import {NoticeType} from "antd/es/message/interface";

export interface MessageState {
	isShow: boolean;
	type: NoticeType;
	content: string;
	setMessages: (type: NoticeType, content: string) => void;
}

export const useMessageStore = create<MessageState>((set, get) => ({
	isShow: false,
	type: 'info',
	content: '',
	setMessages: (type: NoticeType, content: string) => {
		set({ isShow: true, type , content });
	},
}));
